import { useTranslation } from "react-i18next";
import { Breadcrumbs, Typography } from "@mui/material";
import React from "react";

interface BreadPathProps {
  path: string;
}

export const BreadPath: React.FC<BreadPathProps> = ({ path }) => {
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb" separator="/">
        <Typography color="text.primary">{t("pathHome")}</Typography>

        <Typography color="text.primary">
          {t("pathComparePortfolios")}
        </Typography>

        {path === "root" && (
          <Typography color="text.primary">
            {t("pathPortfolioComposition")}
          </Typography>
        )}

        {path !== "root" && (
          <Typography color="text.primary">
            {t("pathPortfolioComposition")}
          </Typography>
        )}

        {path !== "root" && (
          <Typography color="text.primary">{path}</Typography>
        )}
      </Breadcrumbs>
    </>
  );
};
